import { render, staticRenderFns } from "./LevelupPrice.vue?vue&type=template&id=09e3b0d4&"
import script from "./LevelupPrice.vue?vue&type=script&lang=js&"
export * from "./LevelupPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports